module.exports = __webpack_public_path__ + "media/images/sites/health/daniel-2d751a4915664f5716d1df2e8a35868c.jpg";